import React from "react"
import PropTypes from "prop-types"

class Modal extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      buttonText: "Submit"
    }
  }

  render() {
    return(
      <div className="reactModal">
        <div className="newPopUpWrapper">
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default Modal;
